	export enum CommonReportTypeEnum {
		InventoryThresholds = 1,
		UserActivity = 2,
		Telehealth = 3
	}
